module.exports = __webpack_public_path__ + "static/img/newanli-18.2c167e28.jpg";